import { scrollTo } from '../common/utils/index.js';

const ignoredHashes = [
    '',
    '#',
];

let shouldIgnoreNextHashChange = false;

const shouldIgnoreHash = (hash) => (
    ignoredHashes.includes(hash)
    || hash.startsWith('#/')
);

const getAnchorScrollBehavior = ($anchor) => (
    $anchor.attr('data-anchor-scroll') || 'smooth'
);

const shouldUpdateUrl = ($anchor) => (
    $anchor.attr('data-anchor-update-url') !== 'false'
);

const getTarget = (hash) => {
    if (shouldIgnoreHash(hash)) {
        return $();
    }

    try {
        return $(hash);
    } catch (error) {
        console.warn(`Invalid anchor selector "${hash}".`);
        return $();
    }
};

const focusTarget = (
    $target,
    {
        preventScroll = true,
    } = {}
) => {
    const target = $target.get(0);

    if (!target) {
        return;
    }

    try {
        target.focus({
            preventScroll,
        });
    } catch (error) {
        target.focus();
    }
};

const processHash = async (hash = window.location.hash) => {
    const $target = getTarget(hash);

    if (!$target.length) {
        return;
    }

    await scrollTo($target);
};

const handleAnchorClick = async ($anchor) => {
    const hash = $anchor.attr('href');
    const $target = getTarget(hash);
    const scrollBehavior = getAnchorScrollBehavior($anchor);
    const shouldFocusTarget = $anchor.is('[data-anchor-focus-target]');

    if (!$target.length) {
        return;
    }

    if (shouldUpdateUrl($anchor)) {
        history.replaceState(
            undefined,
            undefined,
            hash
        );
    }

    if (shouldFocusTarget) {
        focusTarget($target, {
            preventScroll: scrollBehavior !== 'instant',
        });
    }

    if (scrollBehavior === 'instant') {
        return;
    }

    await scrollTo($target);
};

const bindAnchorClicks = () => {
    $('a[href^="#"]')
        .not('[href^="#/"]')
        .on('click', (event) => {
            const $anchor = $(event.currentTarget);
            const hash = $anchor.attr('href');

            if (shouldIgnoreHash(hash)) {
                return;
            }

            if (getAnchorScrollBehavior($anchor) === 'native') {
                shouldIgnoreNextHashChange = hash !== window.location.hash;
                return;
            }

            event.preventDefault();
            handleAnchorClick($anchor);
        });
};

const bindHashChange = () => {
    $(window).on('hashchange', () => {
        if (shouldIgnoreNextHashChange) {
            shouldIgnoreNextHashChange = false;
            return;
        }

        processHash();
    });
};

const initialize = () => {
    processHash();
    bindHashChange();
    bindAnchorClicks();
};

export default {
    initialize,
};
